var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivationSigmoid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.458333 26.458334",
    height: 60,
    width: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(-0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#b9b9b9",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#b9b9b9",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2) rotate(180) translate(6,0)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 0.0,0.0 L 5.0,-5.0 L -12.5,0.0 L 5.0,5.0 L 0.0,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-270.54165)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#b9b9b9",
      strokeWidth: 1.10593092,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.1927862,0,0,1.1996274,-1.5779563,-57.702331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.351304,295.67707 V 273.62161",
    style: {
      fill: "none",
      stroke: "#b9b9b9",
      strokeWidth: 1.10593092,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#b9b9b9",
      strokeWidth: 1.32291663,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 4.8350954e-7,292.36883 H 26.458333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0,289.72299 c 7.0606931,0 10.581361,-4.63376 12.725731,-6.99036 2.14437,-2.3566 6.841127,-7.56172 13.732602,-7.56172",
    style: {
      fill: "none",
      stroke: "#6a6a6a",
      strokeWidth: 1.32291663,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationSigmoid);
export default __webpack_public_path__ + "static/media/activation_sigmoid.a3d9d493d4c6e985c1762d67d9c96e11.svg";
export { ForwardRef as ReactComponent };